import type { NextPage } from 'next'
import { Footer } from '../components/Footer/Footer'
import { LandingPageHeader } from '../components/Header/LandingPageHeader'
import SEO from '../components/SEO'

const PrivacyPolicyPage: NextPage = () => {
	return (
		<>
			<SEO
				title={'Privacybeleid'}
				description={'Lees het privacybeleid van VRT Open Media'}
			/>
			<LandingPageHeader />
			<div className={'-mt-10'}>
				<aside className="overflow-hidden bg-[url(/heroImage.jpeg)] bg-center bg-no-repeat bg-cover">
					<div className="p-8 md:p-12 lg:px-16 md:py-24 lg:py-36 bg-black/20">
						<div className="text-center">
							<h1
								className="font-bold text-9xl 2xl:text-[200px] text-transparent"
								style={{
									WebkitTextStroke: '2px',
									WebkitTextStrokeColor: 'white',
								}}
							>
								Privacybeleid
							</h1>
						</div>
					</div>
				</aside>
			</div>
			<section className="container max-w-7xl mx-auto px-6">
				<div className="py-8 lg:py-16 mx-auto text-max-dark-blue">
					<div className="pb-4">
						<h2 className="text-4xl font-semibold md:text-5xl lg:text-6xl ">
							Open Media – privacybeleid
						</h2>
						<p className="text-2xl font-light lg:text-2xl text-max-dark-blue py-8">
							Beste bezoeker, bedankt voor je belangstelling voor
							Open Media. We leggen je hier op een zo helder
							mogelijke manier uit welke gegevens we precies van
							je nodig hebben en wat wij ermee doen in het kader
							van Open Media.
						</p>

						<div className="pb-4 text-max-dark-blue">
							<h3 className="text-2xl font-semibold pb-1">
								Wie is verantwoordelijk voor het verzamelen en
								gebruiken van mijn gegevens?
							</h3>
							<p>
								Wij zijn de Vlaamse Radio- en
								Televisieomroeporganisatie (of kortweg de VRT).
								Wij zijn een nv van publiek recht, met
								maatschappelijke zetel te 1043 Brussel, Auguste
								Reyerslaan 52, ingeschreven in de KBO met nummer
								0244.142.664. Dit privacybeleid geldt voor de
								persoonsgegevens die wij van jou verzamelen en
								gebruiken in het kader van Open Media. De
								verzameling en verwerking van je gegevens zijn
								onze verantwoordelijkheden.
							</p>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Waarop is dit privacybeleid van toepassing?
							</h3>
							<p>
								Dit privacybeleid is van toepassing op de
								activiteiten van Open Media, een initiatief van
								de VRT. Open Media is een platform van de VRT,
								waarbij ze een deel van haar content ter
								beschikking stelt aan externe partners. Op die
								manier kunnen externe partners hun apps, sites
								of platformen verrijken met kwalitatieve actua
								of entertainment content. Met Open Media wil de
								VRT haar bestaande content verder exploiteren en
								extra inkomsten ophalen. Die content kan in de
								vorm zijn van een nieuwsfeed, videofragmenten of
								audiofragmenten.
							</p>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Waarom verzamelt de VRT mijn gegevens en op
								welke basis?
							</h3>
							<p>
								Wij verwerken je gegevens voor de volgende
								doeleinden:
							</p>
							<ul className="space-y-3.5 pt-4">
								<li>
									Open Media-account: Om jouw account te
									kunnen creëren, verzamelen wij jouw
									identificatiegegevens (voornaam &
									achternaam, bedrijfsnaam en emailadres).
									Deze gegevens worden ingezameld om jou te
									identificeren als persoon en om met jou te
									kunnen communiceren.
								</li>
								<li>
									Na je registratie voor het Open
									Media-account kunnen we ook om bijkomende
									informatie vragen die ons kan helpen om nog
									meer aangepaste diensten te leveren. Ook als
									je met ons in contact treedt, bv. als je ons
									een e-mail stuurt met vragen, beoordelingen
									of klachten kunnen we de persoonlijke
									gegevens die je gebruikt, verzamelen.
								</li>
								<li>
									De verzameling en het gebruik van gegevens
									voor de hierboven beschreven doeleinden doen
									we allemaal op basis van een overeenkomst
									die we met jou sluiten in het kader van Open
									Media.
								</li>
								<li>
									Statistische doeleinden: Wij gebruiken je
									gegevens ook voor statistische doeleinden,
									om het gebruik en de algemene werking van
									onze diensten met Open Media te analyseren
									en verbeteren. Daarnaast helpen gegevens ons
									te achterhalen welke diensten en content
									voor jullie interessant en bruikbaar zijn.
									Zo kunnen wij Open Media nog beter en
									relevanter voor je maken.
								</li>
								<li>
									Klant- en klachtenbeheer: Via onze
									klantendienst luisteren we graag naar je
									mening en reacties om onszelf elke dag te
									verbeteren. Dat doen we op basis van jouw
									toestemming. Voor alle vragen en/of
									opmerkingen kan je terecht bij de
									klantendienst op het e-mailadres
									klantendienst@vrt.be.
								</li>
								<li>
									Misbruik opsporen en onderzoeken: Wij zouden
									het liefst iedereen blindelings ons
									vertrouwen schenken, maar dat is een beetje
									naïef. Daarom gebruiken we gegevens om
									misbruiken op of via onze platformen te
									voorkomen en op te sporen. Dat doen we om
									illegale praktijken via Open Media te
									vermijden. Dat gebeurt altijd op basis van
									een gerechtvaardigd belang of wettelijke
									grondslag om onze publieke omroep opdracht
									op de juiste manier uit te voeren.
								</li>
							</ul>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Van welke bronnen verzamelt de VRT mijn
								gegevens?
							</h3>
							<p>Wij verzamelen gegevens:</p>
							<ul>
								<li>
									Van jou rechtstreeks, bijvoorbeeld voor het
									aanmaken van een Open Media-account of
									wanneer je het platform gebruikt.
								</li>
							</ul>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Lopen mijn gegevens risico’s bij de VRT?
							</h3>
							<p>
								De uitwisseling van informatie via het internet
								verloopt jammer genoeg nooit volledig veilig.
								Hackers en virussen zijn nu eenmaal onderdeel
								van het internet. Daarom kunnen we het verlies
								van of de toegang door onbevoegden tot gegevens
								nooit helemaal uitsluiten. We doen er wel alles
								aan om jouw gegevens op de best mogelijke manier
								te beschermen. Wij gebruiken verschillende
								beveiligingstechnologieën en -maatregelen om je
								privacy te garanderen. Bovendien evalueren we
								die technologieën en maatregelen herhaaldelijk
								zodat ons systeem zo goed mogelijk bestand is
								tegen de nieuwste virussen en malware. Wij
								werken daarvoor samen met gespecialiseerde
								bedrijven.
							</p>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Welke derde partijen kunnen mijn gegevens
								ontvangen?
							</h3>
							<p>
								Wij kunnen je gegevens doorgeven aan de volgende
								categorieën van ontvangers:
							</p>
							<p>
								Dienstverleners: Wij geven je gegevens door aan
								de dienstverleners waarop we een beroep doen.
								Zij leveren ondersteunende diensten zoals
								infrastructuur- of IT-diensten, het uitvoeren
								van betalingstransacties via onze diensten of
								het afnemen van enquêtes. Die dienstverleners
								krijgen toegang tot bepaalde gegevens en
								informatie in het kader van hun opdracht. Zij
								treden met andere woorden enkel in onze opdracht
								en voor onze rekening op. Zij mogen je gegevens
								dus nooit voor hun eigen doeleinden gebruiken.
							</p>
							<p>
								Overheid en autoriteiten: Wij geven je gegevens
								door aan de overheid en autoriteiten als dat
								wettelijk verplicht is.
							</p>
						</div>
						<div className="pb-4">
							<h3 className="text-2xl font-semibold pb-1">
								Doet de VRT aan geautomatiseerde besluitvorming
								met rechtsgevolgen of heeft ze profielen?
							</h3>
							<p>
								Wij doen niet aan geautomatiseerde
								besluitvorming met rechtsgevolgen. Heel concreet
								betekent dat dat we je gegevens nooit gebruiken
								om beslissingen te nemen zonder menselijke
								tussenkomst die rechtsgevolgen of verregaande
								gevolgen voor jou kunnen hebben.
							</p>
							<div className="pb-4">
								<h3 className="text-2xl font-semibold pb-1">
									Hoe kan ik de gegevens controleren die VRT
									van mij heeft?
								</h3>
								<p>
									Omdat het hier over jouw gegevens gaat,
									vinden we het belangrijk dat je je
									persoonlijke informatie op elk moment kan
									controleren. Je hebt de volgende rechten,
									die je overeenkomstig de voorwaarden en
									modaliteiten van de Europese
									privacywetgeving kan uitoefenen:
								</p>
								<ul className="space-y-3.5 pt-4">
									<li>
										Je hebt het recht op inzage van je
										gegevens. Dat wil zeggen dat je kan
										nagaan welke gegevens wij van jou
										hebben. Voor alle informatie die wij
										over jou zouden kunnen hebben, kan je
										ons via onze klantendienst contacteren.
										Daar zullen we je vraag zo snel mogelijk
										behandelen.
									</li>
									<li>
										Je hebt het recht op rectificatie van je
										gegevens. Het zou kunnen dat wij
										gegevens van jou hebben die niet juist
										of niet meer juist zijn. Ben je verhuisd
										of heb je een nieuw e-mailadres? Dan kan
										je ons via onze klantendienst vragen om
										foute informatie te verbeteren. We
										zullen je vraag dan zo snel mogelijk
										behandelen
									</li>
									<li>
										Je hebt het recht op wissing van je
										gegevens. Als je wil dat we je gegevens
										niet langer bewaren of gebruiken, kan je
										je gegevens bij ons wissen. Je kan
										vragen aan onze klantendienst om
										bijvoorbeeld je Open Media-account en de
										gegevens die eraan verbonden zijn, te
										verwijderen. Wij zijn wel niet altijd
										verplicht je gegevens te wissen wanneer
										je dat vraagt. We hoeven dat enkel te
										doen in de gevallen die door de wet zijn
										bepaald.
									</li>
									<li>
										Je hebt het recht op beperking van je
										gegevens. Je kan ons dus verzoeken om de
										verwerking van je gegevens te beperken.
										In dat geval blijven we je gegevens
										bewaren, maar zullen we het gebruik
										ervan inperken. Dat gebeurt bijvoorbeeld
										wanneer je meent dat je gegevens onjuist
										zijn en je niet wil dat we die gegevens
										nog verwerken totdat ze zijn aangepast.
										Je hebt dit recht ook wanneer de
										bewaring of het gebruik van je gegevens
										door ons onrechtmatig zou zijn, maar je
										niet zou willen dat we de gegevens
										verwijderen. We zijn wel niet altijd
										verplicht om aan dergelijke verzoeken
										tegemoet te komen. We hoeven dat enkel
										te doen in de gevallen die door de wet
										zijn bepaald. Vragen tot de beperking
										van je gegevens kan je via onze
										klantendienst stellen. We zullen je
										vraag dan zo snel mogelijk behandelen.
									</li>
									<li>
										Je hebt het recht bezwaar te maken tegen
										het gebruik van je gegevens. Dat wil
										zeggen dat je je kan verzetten tegen het
										verdere gebruik van je gegevens door
										ons. Je kan dit enkel doen wanneer je
										grondige redenen hebt die verband houden
										met je specifieke situatie. Wij zijn
										trouwens niet altijd verplicht om op een
										dergelijk verzoek in te gaan.
									</li>
									<li>
										Je hebt het recht om je te verzetten
										tegen het gebruik van je gegevens voor
										direct-marketingdoeleinden. Daaronder
										valt onder meer het tonen van reclame
										(op onze websites of in onze apps) die
										aan jouw voorkeur is aangepast. Je kan
										dit recht uitoefenen via de
										cookiesinstellingen. Wil je hier meer
										over weten? Lees dan zeker ons
										cookiesbeleid.
									</li>
									<li>
										Je hebt het recht altijd je toestemming
										in te trekken als de verwerking van je
										gegevens op basis van jouw toestemming
										gebeurt. Je hebt het recht op
										gegevensoverdraagbaarheid. Dat biedt jou
										de mogelijkheid om persoonsgegevens vlot
										van de ene verwerkingsverantwoordelijke
										naar de andere te verplaatsen, te
										kopiëren of door te sturen. Wij zijn wel
										niet altijd verplicht om op dit verzoek
										in te gaan.
									</li>
									<li>
										Wanneer je ons een van de bovenstaande
										vragen stelt, zou het kunnen dat we
										eerst bijkomende informatie vragen. Dat
										moeten we doen om te controleren of jij
										wel de juiste persoon bent.
									</li>
								</ul>
							</div>
							<div className="pb-4">
								<h3 className="text-2xl font-semibold pb-1">
									Hoelang bewaart de VRT mijn gegevens?
								</h3>
								<p>
									Wij zullen je gegevens niet langer bewaren
									dan nodig is voor het vooropgestelde doel en
									voor de duur van de overeenkomst. Als je
									ervoor zou kiezen om je gegevens niet meer
									met ons te delen, dan zullen we je gegevens
									ook niet meer gebruiken. We zullen je
									gegevens wel nog gedurende twee jaar bewaren
									voor de behandeling van mogelijke klachten
									of juridische geschillen. In dat geval zijn
									je gegevens gearchiveerd en slechts beperkt
									toegankelijk. Na afloop van die
									bewaartermijn zullen je gegevens uiteraard
									definitief verwijderd of geanonimiseerd
									worden.
								</p>
							</div>
							<div className="pb-4">
								<h3 className="text-2xl font-semibold pb-1">
									Bij wie kan ik met verdere vragen of
									eventuele klachten rond privacy terecht?
								</h3>
								<p>
									Heb je ons privacybeleid volledig
									doorgenomen, maar nog geen antwoord op je
									vraag gevonden? Stel je vraag in verband met
									privacy dan via onze klantendienst. Daar
									zullen wij je vraag zo snel mogelijk
									beantwoorden. Je kan ook steeds contact
									opnemen met onze klantendienst. Bovendien
									hebben we een zogenaamde Data Protection
									Officer (DPO). Die persoon waakt over de
									bescherming van je gegevens bij de VRT. Onze
									DPO staat je graag te woord via DPO@vrt.be.
									Wij hopen dat je het volgende e-mailadres
									niet snel zal nodig hebben. Maar voor
									klachten met betrekking tot ons
									privacybeleid sturen wij je graag door naar
									klachtenprocedure@vrt.be. Als je wil, kan je
									ook een klacht indienen bij een
									toezichthoudende autoriteit. In België is
									dit de Gegevensbeschermingsautoriteit. Meer
									informatie daarover vind je terug op hun
									website.
								</p>
							</div>
							<div className="pb-4">
								<h3 className="text-2xl font-semibold pb-1">
									Kan dit privacybeleid veranderen?
								</h3>
								<p>
									Dit privacybeleid kan worden aangepast als
									onze diensten of de geldende wetgeving dat
									vragen. Onze onlinediensten zijn
									bijvoorbeeld een dynamische en innovatieve
									omgeving. Dat betekent dat wij voortdurend
									op zoek gaan naar een betere dienstverlening
									op jouw maat. Het is mogelijk dat er nieuwe
									toepassingen komen waarbij we je gegevens op
									een andere manier zullen verzamelen of
									willen gebruiken. Natuurlijk laten we je
									weten wanneer er belangrijke wijzigingen
									zijn, en zullen we je toestemming vragen als
									dat nodig is.
								</p>
								<p className="pt-5">
									Dit privacybeleid werd geüpdatet op
									30/11/2022
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
		</>
	)
}

export default PrivacyPolicyPage
